import { gql } from "@apollo/client";

export const CONSUMER_ACCEPTS_SCHEDULED_SERVICE = gql`
  mutation ConsumerAcceptsScheduledService($serviceId: ID!) {
    consumerAcceptsScheduledService(serviceId: $serviceId) {
      id
      status
      consumerApproved
    }
  }
`;

export const CONSUMER_REQUEST_SCHEDULED_SERVICE_CHANGES = gql`
  mutation ConsumerRequestScheduledServiceChanges(
    $input: ConsumerScheduledServiceChangesInput!
  ) {
    consumerRequestScheduledServiceChanges(input: $input) {
      id
      status
    }
  }
`;
